import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../auth/auth.context'
import { LanguageSwitcher } from '../language-switcher'
import { useChatUnread } from '../../hooks/use-chat-unread'
import { Bell, Search } from 'lucide-react'

export default function Topline() {
  const { t } = useTranslation()
  const { company, user } = useAuth()
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const { data: chatUnread = 0 } = useChatUnread()

  const getTitle = () => {
    if (pathname === '/') return t('nav.dashboard')
    if (pathname.startsWith('/modules')) return t('nav.modules')
    if (pathname.startsWith('/users')) return t('nav.employees')
    if (pathname.startsWith('/weiterbildung')) return t('nav.weiterbildung')
    if (pathname.startsWith('/companies')) return t('nav.companies')
    if (pathname.startsWith('/profile')) return t('nav.profile')
    if (pathname.startsWith('/bulletin-board')) return t('nav.bulletinBoard')
    if (pathname.startsWith('/absence-requests')) return t('nav.absenceRequests')
    if (pathname.startsWith('/time-tracking')) return t('nav.timeTracking')
    if (pathname.startsWith('/chat')) return t('nav.chat')
    if (pathname.startsWith('/subscription')) return t('nav.subscription')
    if (pathname.startsWith('/billing-overview')) return t('nav.billing')
    const parts = pathname.split('/').filter(Boolean)
    const last = parts[parts.length - 1] || t('common.pageFallback')
    return last.charAt(0).toUpperCase() + last.slice(1)
  }

  return (
    <header
      className="sticky top-0 z-30 flex items-center justify-between h-[56px] px-6 bg-white border-b border-neutral-100"
    >
      {/* Title */}
      <h1 className="text-lg font-semibold text-neutral-900 pl-10 lg:pl-0">{getTitle()}</h1>

      {/* Right actions */}
      <div className="flex items-center gap-1">
        <LanguageSwitcher />
        <button
          className="w-9 h-9 rounded-lg flex items-center justify-center text-neutral-400 hover:text-neutral-700 hover:bg-neutral-50 transition-colors"
          aria-label={t('common.search')}
        >
          <Search className="w-[18px] h-[18px]" />
        </button>
        <button
          type="button"
          onClick={() => navigate('/chat')}
          className="w-9 h-9 rounded-lg flex items-center justify-center text-neutral-400 hover:text-neutral-700 hover:bg-neutral-50 transition-colors relative"
          aria-label={t('nav.chat')}
        >
          <Bell className="w-[18px] h-[18px]" />
          {chatUnread > 0 && (
            <span className="absolute top-1.5 right-1.5 w-2 h-2 rounded-full bg-error-500" />
          )}
        </button>

        <div className="w-px h-6 bg-neutral-100 mx-2" />

        {/* User avatar */}
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center text-white text-xs font-semibold">
            {user?.firstName?.charAt(0)}{user?.lastName?.charAt(0)}
          </div>
          <div className="hidden md:block">
            <p className="text-sm font-medium text-neutral-900 leading-tight">
              {user?.firstName} {user?.lastName}
            </p>
            <p className="text-xs text-neutral-400 leading-tight">{company?.name}</p>
          </div>
        </div>
      </div>
    </header>
  )
}
